import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgClass } from '@angular/common';
import { ValidationFormComponent } from '../validation-form/validation-form.component';
import {
  NoLeadingSpaceDirective,
  NumberValueDirective,
  PositiveNumbersDirective,
} from '@core-utils';
import { KeeniconComponent } from '../../partials';
import { uiKitScope } from '../../constants/ui-constant';

@Component({
  selector: 'ui-form-password',
  imports: [
    ReactiveFormsModule,
    ValidationFormComponent,
    NgClass,
    PositiveNumbersDirective,
    FormsModule,
    NoLeadingSpaceDirective,
    NumberValueDirective,
    KeeniconComponent,
  ],
  templateUrl: './form-password.component.html',
  styleUrl: './form-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormPasswordComponent {
  control = input<AbstractControl>();
  global = input<boolean>(true);
  type = model<'text' | 'password'>('password');
  placeholder = input<string>('');
  class = input<string>('');
  skipValidation = input<boolean>(false);
  noNegative = input<boolean>(false);
  isNumber = input<boolean>(false);
  value = input<string | number | null>('');
  description = input<string>('');
  readonly = input<boolean>(false);
  showPassword = false;

  get formControl(): FormControl {
    return this.control() as FormControl;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.type.set(this.showPassword ? 'text' : 'password');
  }

  protected readonly uiKitScope = uiKitScope;
}
